import React from 'react'
import { Stack, Typography, Link } from '@mui/material'
import { appendJDLinkToHeapLocation, showIntercom, trackAnalyticEvent, ANALYTICS_LOCATIONS, isInIframe } from '../../../utils'
import { ContentBox, StyledBadge, StyledButton, StyledCard, StyledContentTypography } from './oauth-integration-additional-card.styles'

type Props = {
	isAdditionalActionDisabled: boolean,
	additionalUrl: string,
	additionalUrlText: string,
	integrationTitle: string,
	buttonText?: string,
}

export const OAuthIntegrationAdditionalCard: React.FC<Props> = ( {
	isAdditionalActionDisabled,
	additionalUrlText,
	additionalUrl,
	integrationTitle,
	buttonText = 'Enable T3 Access',
} ) => {
	const isInAnIframe = React.useRef( isInIframe() ).current

	const onAdditionalActionClick = () => {
		trackAnalyticEvent(
			ANALYTICS_LOCATIONS.MANAGE_PAGE,
			'Click',
			appendJDLinkToHeapLocation( 'Enable T3 Access', integrationTitle ),
		)
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if ( isInAnIframe ) {
			window.parent.postMessage( {
				type: 'navigate',
				target: '_self',
				href: additionalUrl,
			}, '*' )
		} else {
			window.location.href = additionalUrl
		}
	}

	const onContactSupportClick = () => {
		trackAnalyticEvent(
			ANALYTICS_LOCATIONS.MANAGE_PAGE,
			'Click',
			appendJDLinkToHeapLocation( 'Contact Support', integrationTitle ),
		)
		showIntercom( `I'm having trouble connecting my ${integrationTitle} Account to T3.` )
	}

	return (
		<StyledCard>
			<Stack direction="row" spacing={2} alignItems="flex-start">
				<StyledBadge
					badgeContent={2}
					color={isAdditionalActionDisabled ? 'default' : 'primary'}
					style={{ marginTop: '12px', marginLeft: '14px', marginRight: '5px' }}
				/>
				<ContentBox style={{ flex: 1 }}>
					<StyledContentTypography variant="h4">
						Enable Access to T3
					</StyledContentTypography>
					<StyledContentTypography color="textSecondary">
						{additionalUrlText} Having trouble?&nbsp;
						<Link
							underline="hover"
							onClick={onContactSupportClick}
						>
							Contact Support
						</Link>
					</StyledContentTypography>
					<StyledButton
						variant={'outlined'}
						color="primary"
						size="small"
						disabled={isAdditionalActionDisabled}
						onClick={onAdditionalActionClick}
					>
						<Typography fontSize={14}>
							{buttonText}
						</Typography>
					</StyledButton>
				</ContentBox>
			</Stack>
		</StyledCard>
	)
}
